export const PROCESS_WHITELIST_FIELD_TYPE = 'sourceProcessName'
export const PROCESS_WHITELIST_FRIENDLY_FIELD = 'Process'
export const IP_ADDRESS_WHITELIST_FIELD_TYPE = 'remoteHost'
export const IP_ADDRESS_WHITELIST_FRIENDLY_FIELD = 'IP Address'
export const IP_ADDRESS_RULE_TYPE = 'NETWORK'
export const IP_ADDRESS_VALUE_HELP_TEXT =
  'Provide comma or space separated IPv4 address values in CIDR notation (ie 203.0.113.25/32 for a single address, 203.0.113.0/24 for an address range) or Upload CSV'
export const PROCESS_VALUE_HELP_TEXT =
  'Provide comma or space separated values (ie svchost.exe, npsrvhost.exe) or Upload CSV'

export const ALLOWLIST_TYPES = [{ label: 'Detection', value: 'DETECTION' }]

export const ALLOWLIST_DETECTION_LEVELS = [
  { label: 'Ancestor', value: 'ANCESTOR' },
  { label: 'Parent', value: 'PARENT' },
  { label: 'Current', value: 'CURRENT' }
]

export const ALLOWLIST_FIELDS = [
  { label: 'Process Name', value: 'COMM', eventTypeField: 'processname' },
  { label: 'Binary Path', value: 'BINARY', eventTypeField: 'processbinarypath' },
  { label: 'Command Line', value: 'COMMAND_LINE', eventTypeField: 'processcommandline' },
  { label: 'Process SID', value: 'SID', eventTypeField: 'processsid' },
  { label: 'Process Edge', value: 'SPAWNED_COMM', eventTypeField: 'targetprocessname' },
  { label: 'Target Binary Path', value: 'SPAWNED_BINARY', eventTypeField: 'targetbinarypath' },
  { label: 'Target Process SID', value: 'TARGET_SID', eventTypeField: 'targetprocesssid' },
  { label: 'Artifact Path', value: 'ARTIFACT', eventTypeField: 'artifactpath' },
  { label: 'Username', value: 'USERNAME', eventTypeField: 'username' },
  { label: 'Hostname', value: 'HOSTNAME', eventTypeField: 'hostname' },
  { label: 'Local IP', value: 'LOCAL_IP', eventTypeField: 'localip' },
  { label: 'Local Port', value: 'LOCAL_PORT', eventTypeField: 'localport' },
  { label: 'Remote IP', value: 'REMOTE_IP', eventTypeField: 'remoteip' },
  { label: 'Remote Port', value: 'REMOTE_PORT', eventTypeField: 'remoteport' },
  // { label: 'Tag', value: 'TAG' },
  { label: 'File', value: 'COMM_SHA256', eventTypeField: 'filehash' },
  { label: 'DNS', value: 'DNS', eventTypeField: 'dnsentry' }
]

export const ALLOWLIST_FIELDS_GROUP = [
  {
    label: 'Ancestor',
    value: 'ANCESTOR',
    options: [
      { label: 'Process Name', value: 'COMM', id: 'ANCESTOR_COMM', eventTypeField: 'processname', level: 'ANCESTOR' },
      {
        label: 'Binary Path',
        value: 'BINARY',
        id: 'ANCESTOR_BINARY',
        eventTypeField: 'processbinarypath',
        level: 'ANCESTOR'
      },
      {
        label: 'Command Line',
        value: 'COMMAND_LINE',
        id: 'ANCESTOR_COMMAND_LINE',
        eventTypeField: 'processcommandline',
        level: 'ANCESTOR'
      }
    ]
  },
  {
    label: 'Parent',
    value: 'PARENT',
    options: [
      { label: 'Process Name', value: 'COMM', id: 'PARENT_COMM', eventTypeField: 'processname', level: 'PARENT' },
      {
        label: 'Binary Path',
        value: 'BINARY',
        id: 'PARENT_BINARY',
        eventTypeField: 'processbinarypath',
        level: 'PARENT'
      },
      {
        label: 'Command Line',
        value: 'COMMAND_LINE',
        id: 'PARENT_COMMAND_LINE',
        eventTypeField: 'processcommandline',
        level: 'PARENT'
      },
      { label: 'Process SID', value: 'SID', id: 'PARENT_SID', eventTypeField: 'processsid', level: 'PARENT' }
    ]
  },
  {
    label: 'Current',
    value: 'CURRENT',
    options: [
      { label: 'Process Name', value: 'COMM', id: 'CURRENT_COMM', eventTypeField: 'processname', level: 'CURRENT' },
      {
        label: 'Binary Path',
        value: 'BINARY',
        id: 'CURRENT_BINARY',
        eventTypeField: 'processbinarypath',
        level: 'CURRENT'
      },
      {
        label: 'Command Line',
        value: 'COMMAND_LINE',
        id: 'CURRENT_COMMAND_LINE',
        eventTypeField: 'processcommandline',
        level: 'CURRENT'
      },
      { label: 'Process SID', value: 'SID', id: 'CURRENT_SID', eventTypeField: 'processsid', level: 'CURRENT' },
      {
        label: 'Process Edge',
        value: 'SPAWNED_COMM',
        id: 'CURRENT_SPAWNED_COMM',
        eventTypeField: 'targetprocessname',
        level: 'CURRENT'
      },
      {
        label: 'Target Binary Path',
        value: 'SPAWNED_BINARY',
        id: 'CURRENT_SPAWNED_BINARY',
        eventTypeField: 'targetbinarypath',
        level: 'CURRENT'
      },
      {
        label: 'Target Process SID',
        value: 'TARGET_SID',
        id: 'CURRENT_TARGET_SID',
        eventTypeField: 'targetprocesssid',
        level: 'CURRENT'
      },
      {
        label: 'Artifact Path',
        value: 'ARTIFACT',
        id: 'CURRENT_ARTIFACT',
        eventTypeField: 'artifactpath',
        level: 'CURRENT'
      },
      { label: 'Username', value: 'USERNAME', id: 'CURRENT_USERNAME', eventTypeField: 'username', level: 'CURRENT' },
      { label: 'Hostname', value: 'HOSTNAME', id: 'CURRENT_HOSTNAME', eventTypeField: 'hostname', level: 'CURRENT' },
      { label: 'Local IP', value: 'LOCAL_IP', id: 'CURRENT_LOCAL_IP', eventTypeField: 'localip', level: 'CURRENT' },
      {
        label: 'Local Port',
        value: 'LOCAL_PORT',
        id: 'CURRENT_LOCAL_PORT',
        eventTypeField: 'localport',
        level: 'CURRENT'
      },
      { label: 'Remote IP', value: 'REMOTE_IP', id: 'CURRENT_REMOTE_IP', eventTypeField: 'remoteip', level: 'CURRENT' },
      {
        label: 'Remote Port',
        value: 'REMOTE_PORT',
        id: 'CURRENT_REMOTE_PORT',
        eventTypeField: 'remoteport',
        level: 'CURRENT'
      },
      // { label: 'Tag', value: 'TAG', level: 'CURRENT' },
      { label: 'File', value: 'COMM_SHA256', id: 'CURRENT_COMM_SHA256', eventTypeField: 'filehash', level: 'CURRENT' },
      { label: 'DNS', value: 'DNS', id: 'CURRENT_DNS', eventTypeField: 'dnsentry', level: 'CURRENT' }
    ]
  }
]

/*
ProcessName - COMM
ProcessBinaryPath - BINARY
ProcessCommandLine - COMMAND_LINE
ProcessSID - SID
TargetProcessName (Process -> Process edges such as OpenProcess, ThreadInjects) - SPAWNED_COMM
TargetBinaryPath - SPAWNED_BINARY
TargetProcessSID - TARGET_SID
ArtifactPath - ARTIFACT
Username - USERNAME
Hostname (check with IQhub how this can be derived) - HOSTNAME
LocalIP - LOCAL_IP
LocalPort - LOCAL_PORT
RemoteIP - REMOTE_IP
RemotePort - REMOTE_PORT
Tag (limited to a few, we should think about this openly)
File Hash - COMM_SHA256
DNS Entry - DNS
*/
// public enum Key {
//   COMM,
//   SPAWNED_COMM,
//   BINARY,
//   SPAWNED_BINARY,
//   ARTIFACT,
//   COMMAND_LINE,
//   REMOTE_IP
//   REMOTE_IP,
//   REMOTE_PORT,
//   LOCAL_IP,
//   LOCAL_PORT,
//   SID,
//   TARGET_SID,
//   COMM_SHA256,
//   DNS,
//   USERNAME,
//   HOSTNAME

export const ALLOWLIST_OPERATORS = [
  { label: 'Not Equals', value: 'NOTEQUALS' },
  { label: 'Equals', value: 'EQUALS' },
  { label: 'In', value: 'IN' },
  { label: 'Starts with', value: 'STARTSWITH' },
  { label: 'Ends with', value: 'ENDSWITH' },
  { label: 'Contains', value: 'CONTAINS' }
]



// WEBPACK FOOTER //
// ./src/constants/rules.constants.js